import React from 'react';
import moment from 'moment';
import {TextToolTip} from "components";

export const HistoryCard = ({data}) => {
    const correctDate = moment.utc(data?._id).format('MMMM DD, YYYY');

    return (
        <div className="history-card-block">
            <p className="history-card-block__date">{correctDate}</p>
            <div className="history-card-block__container">
                {data?.data?.map((i, j) => (
                    <div key={j} className="history-card-block__row">
                        <div className="history-card-block__cell" style={{width: '15%'}}>
                            <div className="history-card-block__user-dot">
                                <div className="history-card-block__dot"/>

                                <TextToolTip
                                    classNameText="history-card-block__user"
                                    text={i?.user && i?.user?.firstName ? `${i?.user?.firstName} ${i?.user?.lastName ? i?.user?.lastName : ''}` : 'System'}
                                    content={i?.user && i?.user?.firstName ? `${i?.user?.firstName} ${i?.user?.lastName ? i?.user?.lastName : ''}` : 'System'}
                                />
                            </div>
                        </div>

                        <div className="history-card-block__cell" style={{width: '7%'}}>
                            <TextToolTip
                                classNameText="history-card-block__time"
                                text={i?.time}
                                content={i?.time}
                            />
                        </div>

                        <div className="history-card-block__cell" style={{width: '73%'}}>
                            <p className='history-card-block__title'>
                                {i?.title}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};